import { render, staticRenderFns } from "./OnlineBookingManualapproveForm.vue?vue&type=template&id=2db11d5a"
import script from "./OnlineBookingManualapproveForm.vue?vue&type=script&lang=js"
export * from "./OnlineBookingManualapproveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports